/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface BackArrowProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
const BackArrow: React.SFC<BackArrowProps> = ({size, ...props}) => (
  <svg viewBox="0 0 37 30" fill="currentColor" width={ size || "37" } height={ size || "30" } {...props}>
    <path d="M254.152 162.625C254.66099999999997 162.11 254.66299999999998 161.275 254.152 160.76L243.45499999999998 149.956L274.472 149.956C275.193 149.956 275.77799999999996 149.36599999999999 275.77799999999996 148.637C275.77799999999996 147.909 275.193 147.319 274.472 147.319L243.45499999999998 147.319L254.15099999999998 136.515C254.66099999999997 136 254.66099999999997 135.165 254.15099999999998 134.64999999999998C253.64 134.13599999999997 252.814 134.13599999999997 252.30499999999998 134.64999999999998L239.37999999999997 147.70499999999998C238.87599999999998 148.21399999999997 238.87599999999998 149.06199999999998 239.37999999999997 149.571L252.30499999999998 162.626C252.81499999999997 163.14000000000001 253.64199999999997 163.14000000000001 254.152 162.625C254.66099999999997 162.11 253.642 163.14 254.152 162.625Z"
      fill="currentColor" transform="translate(-239 -134)" />
  </svg>
);
BackArrow.displayName = 'BackArrow';
export default BackArrow;
/* tslint:enable */
/* eslint-enable */
